import { useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface Option {
  value: string;
  label: string;
}

interface EditableSelectCellProps {
  value: string;
  displayValue: string;
  rowId: string;
  columnId: string;
  options: Option[];
  onSave: (rowId: string, columnId: string, newValue: string) => Promise<void>;
}

export function EditableSelectCell({ value, displayValue, rowId, columnId, options, onSave }: EditableSelectCellProps) {
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleChange = async (newValue: string) => {
    if (newValue === value) {
      setEditing(false);
      return;
    }
    setSaving(true);
    try {
      await onSave(rowId, columnId, newValue);
      setEditing(false);
    } catch {
      // onSave handles the error toast
    } finally {
      setSaving(false);
    }
  };

  if (editing) {
    return (
      <Select value={value} onValueChange={handleChange} disabled={saving} onOpenChange={(open) => { if (!open) setEditing(false); }}>
        <SelectTrigger className="h-7 text-sm w-[160px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  return (
    <span
      className="text-sm cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 px-1 py-0.5 rounded transition-colors"
      onClick={() => setEditing(true)}
      title="Click to change"
    >
      {displayValue || <span className="text-gray-400">-</span>}
    </span>
  );
}
